const SLOTS_PREFIX = 'slots-oceans:';
const SLOTS_TENANT = '661abea4-94a9-4a1e-acc2-b9dd3bb21268';

// Convert only at the source-application boundary (overview / scoped preview).
// Chat APIs must continue using their qualified IDs. Never unwrap another realm
// or interpret a Slots ID in an unrelated tenant's context.
export const sourceChatPlayerIdentity = (playerId, tenantId) => {
  const player = String(playerId || '').trim();
  const tenant = String(tenantId || '').trim();
  const isSlots = tenant === SLOTS_TENANT || tenant === SLOTS_PREFIX + SLOTS_TENANT;
  const sourcePlayer = isSlots && player.startsWith(SLOTS_PREFIX)
    ? player.slice(SLOTS_PREFIX.length)
    : player;
  return {
    playerId: sourcePlayer && !sourcePlayer.includes(':') ? sourcePlayer : player,
    tenantId: tenant === SLOTS_PREFIX + SLOTS_TENANT ? SLOTS_TENANT : tenant,
  };
};

// Only the known Slots realm may be qualified from a source profile. Other
// tenants/realms retain their own identifiers and cannot alias a Slots player.
export const centralChatPlayerIdentity = (playerId, tenantId, central = false) => {
  const player = String(playerId || '').trim();
  const tenant = String(tenantId || '').trim();
  const isSlots = tenant === SLOTS_TENANT || tenant === SLOTS_PREFIX + SLOTS_TENANT;
  return central && isSlots ? {
    playerId: player && !player.includes(':') ? SLOTS_PREFIX + player : player,
    tenantId: SLOTS_PREFIX + SLOTS_TENANT,
  } : { playerId: player, tenantId: tenant };
};
